import React, { useState } from "react";
import "./Bulk.css";

const Bulk = () => {
  const [products, setProducts] = useState([{ name: "", quantity: "" }]);

  const handleProductChange = (index, field, value) => {
    const updated = [...products];
    updated[index][field] = value;
    setProducts(updated);
  };

  const addProduct = () => {
    setProducts([...products, { name: "", quantity: "" }]);
  };

  const removeProduct = (index) => {
    const updated = products.filter((_, i) => i !== index);
    setProducts(updated);
  };

  return (
    <div className="bulk-container">
      <h2 className="bulk-title">Ordering in Bulk?</h2>
      <p className="bulk-subtitle">
        We are happy to support and offer discounts on bulk orders. With our supply and delivery network,
        we are well equipped to take care of all your bulk purchase needs. Get a customized quote for your
        bulk order in three easy steps.
      </p>
      <div className="bulk-steps">
        <div className="step"><span>01</span><p>SUBMIT YOUR REQUIREMENTS</p></div>
        <div className="step"><span>02</span><p>WE REVIEW YOUR REQUEST</p></div>
        <div className="step"><span>03</span><p>YOU GET OUR BEST QUOTE</p></div>
      </div>

      <p className="bulk-note">Write to us and we will get back to you shortly!</p>

      <form className="bulk-form">
        {products.map((product, index) => (
          <div className="bulk-product-row" key={index}>
            <input
              type="text"
              className="bulk-input"
              placeholder="Search Product"
              value={product.name}
              onChange={(e) => handleProductChange(index, "name", e.target.value)}
            />
            <input
              type="text"
              className="bulk-input"
              placeholder="Quantity"
              value={product.quantity}
              onChange={(e) => handleProductChange(index, "quantity", e.target.value)}
            />
            {index > 0 && (
              <button type="button" className="bulk-remove" onClick={() => removeProduct(index)}>
                × REMOVE THIS PRODUCT
              </button>
            )}
          </div>
        ))}
        <button type="button" className="bulk-add" onClick={addProduct}>
          + ADD ANOTHER PRODUCT
        </button>

        <div className="bulk-upload-section">
          <input type="file" className="bulk-file" />
          <button type="button" className="bulk-upload">Upload</button>
        </div>

        <input type="text" className="bulk-input" placeholder="Delivery Address *" required />
        <hr style={{color: "white"}}/>
        <div className="bulk-row">
          <input type="text" className="bulk-input" placeholder="Pincode *" required />
          <input type="date" className="bulk-input" placeholder="Estimated Delivery Date" />
        </div>
        <div className="bulk-row">
          <input type="text" className="bulk-input" placeholder="Name *" required />
          <input type="text" className="bulk-input" placeholder="Company Name" />
        </div>
        <div className="bulk-row">
          <input type="text" className="bulk-input" placeholder="Phone *" required />
          <input type="email" className="bulk-input" placeholder="Email Address *" required />
        </div>

        <textarea className="bulk-textarea" placeholder="Message"></textarea>

        <div className="bulk-terms">
          <input type="checkbox" required /> I Agree to the <a href="#">TERMS OF SERVICE</a>
        </div>

        <button type="submit" className="bulk-submit">SUBMIT</button>
      </form>
    </div>
  );
};

export default Bulk;
